export enum StarTypes {
  POST_STAR = "POST_STAR",
  POST_STAR_SUCCESS = "POST_STAR_SUCCESS",
  POST_STAR_FAILED = "POST_STAR_FAILED",
  POST_BENEFIT_STAR = "POST_BENEFIT_STAR",
  POST_BENEFIT_STAR_SUCCESS = "POST_BENEFIT_STAR_SUCCESS",
  POST_BENEFIT_STAR_FAILED = "POST_BENEFIT_STAR_FAILED",
  REMOVE_ALERT = "REMOVE_ALERT",
}
